"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIMovetexPlanningChangedOrderEntry = void 0;
const imovetex_planning_changed_delivery_order_1 = require("./imovetex-planning-changed-delivery-order");
function parseIMovetexPlanningChangedOrderEntry(data) {
    if (data.deliveryOrder !== null && typeof data.deliveryOrder === 'object')
        data.deliveryOrder = (0, imovetex_planning_changed_delivery_order_1.parseIMovetexPlanningChangedDeliveryOrder)(data.deliveryOrder);
    return data;
}
exports.parseIMovetexPlanningChangedOrderEntry = parseIMovetexPlanningChangedOrderEntry;
